import { render, staticRenderFns } from "./TeachRoomPPT2.vue?vue&type=template&id=af7e8d28&scoped=true&"
import script from "./TeachRoomPPT2.vue?vue&type=script&lang=js&"
export * from "./TeachRoomPPT2.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomPPT2.vue?vue&type=style&index=0&id=af7e8d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7e8d28",
  null
  
)

export default component.exports